import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * AuthCallback - Processes the session_id from Emergent Auth OAuth flow.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setToken, setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        const res = await fetch(`${API}/api/auth/google-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.detail || 'Google sign-in failed');
        }

        const data = await res.json();
        setToken(data.access_token);
        localStorage.setItem('pulse_user', JSON.stringify(data.user));
        setUser(data.user);

        // Clean the hash from URL and redirect to projects
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/projects', { replace: true });
      } catch (err) {
        console.error('Google auth error:', err);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, setToken, setUser]);

  return null; // Renders nothing — silent redirect
}
